<nav class="ng2-smart-pagination-nav" *ngIf="pager.totalPages > 1">
  <ul *ngIf="pager.pages && pager.pages.length" class="ng2-smart-pagination pagination">
    <li *ngIf="pager.currentPage > 1" class="ng2-smart-page-item page-item info">
      <a (click)="getPage(1)" class="ng2-smart-page-link page-link"><<</a>
    </li>
    <li *ngIf="pager.currentPage > 1" class="ng2-smart-page-item page-item info">
      <a (click)="getPage(pager.currentPage - 1)" class="ng2-smart-page-link page-link"><</a>
    </li>
    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}"  class="ng2-smart-page-item page-item info">
      <a (click)="getPage(page)" class="ng2-smart-page-link page-link">{{page}}</a>
    </li>
    <li *ngIf="pager.currentPage !== pager.totalPages" class="ng2-smart-page-item page-item info">
      <a (click)="getPage(pager.currentPage + 1)" class="ng2-smart-page-link page-link">></a>
    </li>
    <li *ngIf="pager.currentPage !== pager.totalPages"  class="ng2-smart-page-item page-item info">
      <a (click)="getPage(pager.totalPages)" class="ng2-smart-page-link page-link">>></a>
    </li>
  </ul>
</nav>
